import { useJsonAPI } from 'json-api-hooks';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import retrievePath from './iris';

const MAX_IN_STORAGE = 5;

export type VisitPostalCode = (digits: string | number) => void;

export const useVisitPostalCode = (): {
  recentPostalCodes: string[];
  visitPostalCode: (digits: string | number) => void;
} => {
  const { router } = useJsonAPI();
  const location = useLocation();
  const navigate = useNavigate();
  const [recentPostalCodes, addRecentPostalCode] = React.useMemo<[string[], VisitPostalCode]>(() => {
    const rawFromStorage = localStorage.getItem('recentPostalDigits') ?? '[]';
    const current = rawFromStorage ? JSON.parse(rawFromStorage) : [];

    const add = (value: string | number) => {
      const normalizedValue = value.toString();
      const newValue = current.filter((v: string) => v !== normalizedValue);
      newValue.unshift(normalizedValue);
      localStorage.setItem('recentPostalDigits', JSON.stringify(newValue.slice(0, MAX_IN_STORAGE)));
    };

    return [current, add];
  }, []);

  const hash = location.hash ?? '#';
  const visitPostalCode = React.useCallback<VisitPostalCode>((digits) => {
    if (digits) {
      addRecentPostalCode(digits);
      navigate(`${retrievePath(router.resourceRoute({ type: 'postal_codes', id: digits.toString() }))}${hash}`);
    }
  }, []);

  return {
    recentPostalCodes,
    visitPostalCode,
  };
};
